import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#EBA600",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.75",
      d: "M1.5 9 12 3l10.5 6L12 15z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#EBA600",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.75",
      d: "M5.25 11.25v6L12 21l6.75-3.75v-6M22.5 17.25V9M12 15v6"
    }, null, -1)
  ])))
}
export default { render: render }